import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ServerService } from 'src/app/services/server.service';
import { ClipBoardService } from 'src/app/services/clipboard.service';
@Component({
  selector: 'app-create-campaign-review',
  templateUrl: './create-campaign-review.component.html',
  styleUrls: ['./create-campaign-review.component.scss']
})
export class CreateCampaignReviewComponent implements OnInit {
  btnStatus: boolean;
  token = localStorage.getItem('token')
  client_remarks:any;
  issues:any;
  createReviewExistingData:any;
  delivery_target:any = '0';
  leads_delivery:any = '0';
  latest_feedback_received:any = '0';
  latest_qualification:any = '0';
  latest_qualification_oot:any = '0';
  latest_drr:any = '0';
  getAllDetails: any;
  adminUser: any;
  // authToken = localStorage.getItem('token')
  selectedUser:any;
  selectedUsersArray: any = [];
  ids: any = [];
  // clientParticipant = [{
  //   name:'sdsd',
  //   email:'sdsdds@sd.in',
  //   designation:'dsfddf'
  // }]
  client_participants =  [
       
    ];
    hasError = false;
    reviewType:any;
    reviewTypeSelected:any
  constructor(
    private dialogRef: MatDialogRef<CreateCampaignReviewComponent>,
    private _serverService:ServerService,
    private clipBoardService:ClipBoardService,
    private changeDetectorRef: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data
  ) { }

  ngOnInit() {
    // console.log(this.data)
    this.getAllVendorAdmin()
    this.getReviewDetail()
    
    this.createReviewExistingData = this.data;

    // this.addClient()
    this.getCommonDetails();
    // if(this.getAllDetails){
      
    // }
    
   
   
  }
  removeClient(i:any){
    this.client_participants.splice(i,1)
  }
  addClient() {
    this.client_participants.push({
      name: '',
      email: '',
      phone: '',
      designation: '',
      nameError: '',
    });
    if(this.reviewTypeSelected == "External")
    this.validateClients({ stopOnFirstError: false });
  }
  validateClients(options: { stopOnFirstError: boolean } = { stopOnFirstError: true }) {
    this.hasError = false;
  
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
    for (const client of this.client_participants) {
      client.nameError = '';
      client.emailError = '';
  
      let hasClientError = false;
  
      // Name validation
      if (!client.name || client.name.trim() === '') {
        client.nameError = 'Name is required';
        this.hasError = true;
        hasClientError = true;
      }
  
      // Email validation
      if (client.email && !emailRegex.test(client.email)) {
        client.emailError = 'Enter a valid email';
        this.hasError = true;
        hasClientError = true;
      }
  
      // Break only if we're stopping on the first client that has any error
      if (options.stopOnFirstError && hasClientError) {
        break;
      }
    }
  }
  
  setCreateForm(){
    // console.log(this.getAllDetails)
    this.delivery_target = this.getAllDetails.campaign_stats_details.delivery_target?this.getAllDetails.campaign_stats_details.delivery_target:'0';
    this.leads_delivery = this.getAllDetails.campaign_stats_details.leads_delivered_count?this.getAllDetails.campaign_stats_details.leads_delivered_count:'0';
    this.latest_feedback_received = this.getAllDetails.campaign_stats_details.feedback_received_count?this.getAllDetails.campaign_stats_details.feedback_received_count:'0';
    this.latest_qualification = this.getAllDetails.campaign_stats_details.leads_qualified_count?this.getAllDetails.campaign_stats_details.leads_qualified_count:'0';
    this.latest_qualification_oot = this.getAllDetails.campaign_stats_details.leads_qualified_out_of_tat_count?this.getAllDetails.campaign_stats_details.leads_qualified_out_of_tat_count:'0';
    this.latest_drr = this.getAllDetails.campaign_stats_details.drr?this.getAllDetails.campaign_stats_details.drr:'0';
    this.selectedUsersArray  = this.getAllDetails.participants_user;
    // console.log(this.selectedUsersArray)
  }
  close() {
    this.dialogRef.close();
}
getCommonDetails(){
  this._serverService.getAllStatus(this.token).subscribe((data: any) => {
    // console.log(data)
   this.reviewType =  data.campaign_review_review_type
  });
}
create(){

  let url = 'campaign_module/campaign_reviews';
  this.ids = this.selectedUsersArray.map((data)=>{
    return data.id
  })
 
  const temp = this.client_participants.map(({ name, email, phone, designation }) => ({
    name,
    email,
    phone,
    designation
  }));

 if(this.hasError){
  return
 }
//  return;
  let body = {
    "campaign_id": this.createReviewExistingData,
    "client_remarks": this.client_remarks,
    "issue_description": this.issues,
    "participants_id": this.ids, 
    "campaign_stats_details": {
            "delivery_target": this.delivery_target,
            // "time_elapsed": 0,
            "drr": this.latest_drr,
            "leads_delivered_count": this.leads_delivery,
            "leads_qualified_count": this.latest_qualification,
            "feedback_received_count": this.latest_feedback_received,
            "leads_qualified_percent":this.latest_qualification == 0 ||  this.latest_feedback_received == 0 ? 0.00 :(this.latest_qualification / this.latest_feedback_received) * 100,
            "leads_qualified_out_of_tat_count": this.latest_qualification_oot,
            "leads_qualified_out_of_tat_percent": this.latest_qualification_oot == 0 ||  this.latest_feedback_received == 0 ? 0.00 :(this.latest_qualification_oot / this.latest_feedback_received) * 100
        },
        "review_type":this.reviewTypeSelected,
        
  }
  if(this.reviewTypeSelected ==  "External"){
    body["client_participants"] = temp
  }
  // let url = this.data.id;
  this._serverService.createCampaignReview(url,body,this.token).subscribe((data)=>{

      this.dialogRef.close(data);
      this.clipBoardService.showMessgeInText("Review Created Successfully", "success-snackbar")
   
  },
  error => {
   console.error('Review Creation failed', error);
   this.btnStatus = false;
   // this.showComponentLoader = false;
 })

}
resetParticipant(event:any){
  // console.log(event)
    
    if(this.reviewTypeSelected == "External"){
    this.addClient();
    }
    else{
      this.client_participants = []
    }
}
getReviewDetail(){
  let url = 'campaign_module/campaign_reviews/new';
  let body = {
    "campaign_id": this.data,
  }
  // let url = this.data.id;
  this._serverService.getCampaignReviewDetailsForCreation(url,body,this.token).subscribe((data)=>{
    // console.log(data)
    this.getAllDetails = data.data
    this.setCreateForm();
    // console.log(this.getAllDetails)
      // this.dialogRef.close(data);
      // this.clipBoardService.showMessgeInText("Action Item Marked as done Successfully", "success-snackbar")
   
  },
  error => {
   console.error('User Assigned failed', error);
   this.btnStatus = false;
   // this.showComponentLoader = false;
 })

}
disabledForm(){
  
  if(this.client_remarks 
  && this.issues
    && this.selectedUsersArray.length != 0 
     && (this.delivery_target ||  this.delivery_target == 0 && this.delivery_target != '' )
      && (this.latest_drr || this.latest_drr == 0 && this.latest_drr != '')
       && (this.leads_delivery || this.leads_delivery == 0 && this.leads_delivery != '' )
        && (this.latest_qualification || this.latest_qualification == 0 && this.latest_qualification != '')
         && (this.latest_feedback_received || this.latest_feedback_received == 0 && this.latest_feedback_received != '')
           && (this.latest_qualification_oot || this.latest_qualification_oot == 0 && this.latest_qualification_oot != '')
            && (this.reviewTypeSelected && this.latest_qualification_oot != '')
          )
          {
            return false
          }
          else{
            return true
          }
}

getAllVendorAdmin(){
  this._serverService.getallParticipantCampaign(this.token).subscribe((data)=>{
    this.adminUser = data.data;
  
  })
  }
  userType(item) {
    return item.org_admin && !item.role
      ? 'Vendor Admin'
      : !item.org_admin && item.role
      ? 'Vendor Standard User'
      : item.role;
  }
  onUserSelect(selectedUserId: number) {
    this.changeDetectorRef.detectChanges();
  
    if(selectedUserId != undefined){
    const selectedUser = this.adminUser.find(user => user.id === selectedUserId);
    // console.log(selectedUser)
    const userExists = this.selectedUsersArray.some(user => user.id === selectedUser.id);

    if (!userExists) {
      this.selectedUsersArray.push({ id: selectedUser.id, name: selectedUser.name });
     
    }
    this.selectedUser = null;
   
  }
}
  removeUser(user){
    this.selectedUsersArray = this.selectedUsersArray.filter((data)=>data.id != user.id)
    // console.log(this.selectedUsersArray)
  }
  allowOnlyNumbers(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    // console.log(charCode)
    if (
      charCode === 8 ||  
      charCode === 46 || 
      charCode === 9 ||  
      charCode === 27 || 
      charCode === 13    
    ) {
      return true;
    }
   
  
    
    if (charCode >= 48 && charCode <= 57 || charCode >= 96 && charCode <= 105) {
      return true;
    }
  
    
    event.preventDefault();
    return false;
  }
  
}